export const LINK_RESULTS_TEXT = "link-my-application-results-found";
export const LINK_RESULTS_ALERT_TITLE = "link-results-alert-title";
export const LINK_RESULTS_ALERT_TEXT = "link-results-alert-text";
export const LINK_RESULTS_CREATE_BUTTON = "link-application-create-button";
export const LINK_RESULTS_CANCEL_BUTTON = "link-application-cancel-button";
export const LINK_APPLICATION_RESULTS_BACK_BUTTON =
  "link-application-results-back-button";
export const LINK_APPLICATION_CHECK_ICON_ID =
  "link-application-results-success-icon";
export const LINK_APPLICATION_FORM_ID = "link-application-form";
export const HAP_ID_LABEL = "link-application-hapId-label";
export const NAME_HAP_ID = "hapId";
export const NAME_DOB = "dateOfBirth";
export const LINK_APPLICATION_ALREADY_TEXT = "link-application-already-text";
export const LINK_APPLICATION_TEXT = "link-application-text";
export const LINK_APPLICATION_TEXT_LOGIN = "link-application-text-logIn";
export const LINK_APPLICATION_ALERT_TEXT = "link-application-alert-text";
export const LINK_APPLICATION_SEARCH_BUTTON = "link-application-search-button";
export const LINK_APPLICATION_SEARCH_HEADING =
  "link-application-search-heading";
export const LINK_APPLICATION_HEADING = "link-application-heading";
export const LINK_APPLICATION_SEARCH_TEXT = "link-application-search-text";
export const LINK_APPLICATION_SEARCH_LINK = "link-application-search-link";
export const LINK_APPLICATION_PROVIDER_SEARCH_LINK =
  "link-application-provider-search-link";
export const LINK_APPLICATION_SEARCH_TEXT_TWO =
  "link-application-search-text-two";
export const LINK_APPLICATION_SEARCH_TEXT_THREE =
  "link-application-search-text-three";
export const LINK_APPLICATION_RESULTS_ROUTE = "/link-application-results";
export const SEX_REQUIRED_ERROR = "sex-required-error";
export const NAME_FIRST_NAME = "firstName";
export const NAME_LAST_NAME = "lastName";
export const NAME_ZIP_CODE = "zipCode";
export const NAME_DATE_OF_BIRTH = "dateOfBirth";
export const NAME_SEX = "sexCode";
export const SEX_LABEL = "sex";
export const NEED_HELP_TEXT = "need-help-text";
export const NEED_HELP_TEXT_TWO = "need-help-text-two";
export const SEARCH_HAP_ID_ALERT_TEXT = "search-hap-id-alert-text";
export const SEARCH_HAP_ID_HEADING = "search-hapId-heading";
export const PERSONAL_INFORMATION_HEADING = "personal-information";
export const LINK_APPLICATION_BACK_BUTTON_ID = "link-application-back-button";
export const HAP_TOOLTIP_TEXT = "hap-id-tooltip-text";
export const LINK_APPLICATION_SEARCH_BUTTON_ID =
  "link-application-search-button";
export const RESULT_HAP_CARD_ALERT = "result-hap-card-alert";
export const LINK_MY_APPLICATION_ALERT_CONTENT =
  "link-my-application-alert-content";
export const LINK_MY_APPLICATION_SEARCH_ALERT =
  "link-my-application-search-alert";
export const LINK_APPLICATION_RESULTS_HAP_ICON =
  "link-application-results-hap-icon";
export const LINK_MY_APPLICATION_ALERT = "link-my-application-alert";
export const APPLICATION_LINKED_SUCCESSFULLY =
  "APPLICATION_SUCCESSFULLY_LINKED";
export const NO_APPLICATION_FOUND = "NO_APPLICATION_FOUND";
export const APPLICATION_ALREADY_LINKED = "APPLICATION_ALREADY_LINKED";
export const APPLICATION_ALREADY_EXIST = "APPLICATION_ALREADY_EXIST";
export const LINK_APPLICATION = "LINK_APPLICATION";
